var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"w-logo",style:(_vm.rootStyle),attrs:{"nuxt":""},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.logoPath,"alt":_vm.$t('glob_home'),"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }